import store from '../store/index';

const createIngredientGuard = (to, from, next) => {
  store.dispatch('ingredients/LoadAllergens').then(() => next());
  store.dispatch('ingredients/LoadAllIngredients').then(() => next());
  store.dispatch('ingredients/LoadAllGroupIngredients').then(() => next());
}

export default createIngredientGuard;
